import {Component, ViewChild} from '@angular/core';
import {ProductQuery} from '@services/resource/search-product-resources';
import {VoteService} from '@services/vote.service';
import {MatDialog} from '@angular/material/dialog';
import {DownloadDialogConfig, ExcelDownloadDialogComponent} from '@ma-dashboard/excel-export/excel-download-dialog/excel-download-dialog.component';
import {MaVotingWidgetComponent} from '@ma-dashboard/voting-overview/ma-voting-widget/ma-voting-widget.component';
import {ExecuteUpdatesComponent} from '@ma-dashboard/voting-overview/execute-updates/execute-updates.component';
import {UUID} from '@util/types';
import {ProductListComponent} from '@app/product-list/product-list.component';
import {MarkantElementsModule} from '@markant/elements-angular';
import {MinPrivilegeDirective} from '@util/directives/min-privilege.directive';

@Component({
  selector: 'app-voting-overview',
  templateUrl: './voting-overview.component.html',
  styleUrls: ['./voting-overview.component.scss'],
  standalone: true,
  imports: [ProductListComponent, MarkantElementsModule, MinPrivilegeDirective, MaVotingWidgetComponent],
})
export class VotingOverviewComponent {
  @ViewChild(ProductListComponent)
  private readonly productListComponent: ProductListComponent;
  public cycleId?: UUID;

  constructor(
    private readonly voteService: VoteService,
    private readonly dialog: MatDialog,
  ) {}

  openExecuteUpdatesDialog(): void {
    if (!this.cycleId) {
      return;
    }
    const data = {cycleId: this.cycleId};
    this.dialog
      .open(ExecuteUpdatesComponent, {data, width: '800px'})
      .afterClosed()
      .subscribe(() => {
        this.productListComponent.updateList();
      });
  }

  openDownloadDialog(): void {
    if (!this.cycleId) {
      return;
    }
    const fileName = 'EXCEL';
    const downloadResponse = this.voteService.generateExport(this.cycleId);
    const data: DownloadDialogConfig = {fileName, downloadResponse};
    this.dialog.open(ExcelDownloadDialogComponent, {data});
  }

  public queryChanged(q: ProductQuery) {
    if (q.cycleFilter !== 'all' && q.cycleFilter !== 'none') {
      this.cycleId = q.cycleFilter;
    } else {
      this.cycleId = undefined;
    }
  }
}
